import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import { TFormState } from '../../../../models/forms.model';
import { IStepStyles, STEPS_STYLING_MAP } from '../../models/contract-styling-consts';
import { ContractDataService } from '../../services/contract-data.service';
import { GraphKnDataService } from '../../../graph-konva/services/graph-kn.data.service';
import { contractStatusToModifyRM } from '../../models/contract-internal-models';
import { ContractFormService } from '../../services/contract-form.service';

@Component({
    selector: 'app-contract-roadmap-menu',
    templateUrl: './contract-roadmap-menu.component.html',
    styleUrl: './contract-roadmap-menu.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush,
 
})
export class AppContractRoadmapMenuComponent {
    @Input() contractStatus:string = ''
    @Input() isContractInterDomain:boolean = false
    public stepsStylingMap:{key:string,value:IStepStyles}[] = []
    public formState:TFormState = 'Default'
    public isCurrentMemberInContract = true;
    public ContractStatusToModifyRM = contractStatusToModifyRM
    constructor(
      public contractDataService:ContractDataService,
      public contractFormService:ContractFormService,
      public knDataService:GraphKnDataService,
    ) {  }

    ngOnInit(): void {
      this.stepsStylingMap = [...STEPS_STYLING_MAP]
        .filter(el=>['payment','general_credit_letter'].includes(el[0])===false)
        .map(el=>{return {key:el[0],value:el[1]}})
    }
    cancelChangedData() {
      this.contractDataService.subContractEdited.next(false)
      this.contractDataService.subContractModifiedSaveOrCancel.next(false)
    }
    saveChangedData() {
      this.contractDataService.subContractEdited.next(false)
      this.contractDataService.subContractModifiedSaveOrCancel.next(true)
    }
    showNewStepPreview(stepType:any,ev:Event) {
      if (
        this.contractDataService.subContractFormState.value==='Default' && 
        this.contractDataService.subContractBlockEdit.value===false && 
        this.contractDataService.subContractStepCreateNew.value.action === 'none' && 
        this.isContractInterDomain === false
      ) 
      {
        this.contractDataService.subContractStepCreateNew.next({action:'preView',stepType:stepType})
      }
    }
    removeNewStepPreview() {
      this.contractDataService.subContractStepCreateNew.next({action:'none'})
    }
    addNewStep(stepType:any) {
      this.contractDataService.subContractStepCreateNew.next({action:'add',stepType:stepType})
    }
}